import React from 'react';
import {
    FluentProvider,
    Theme, webLightTheme 
} from '@fluentui/react-components';
import DeckContextProvider from './BridgeEngineDeck';
import GameSettingsContextProvider from './BridgeEngineSettings';
import PlayStateProvider from './BridgeEnginePlay';
import BridgeBoard from './BridgeBoard';

const bridgeTheme: Theme = {
    ...webLightTheme, 
    fontFamilyBase: "Tahoma, Geneva, sans-serif",
    fontSizeBase300: "20px",
    // colorNeutralForeground1: "black",
};

const BridgeMain: React.FC = () => {
    return (
        // <FluentProvider theme={webLightTheme}>
        <FluentProvider theme={bridgeTheme}>
            <DeckContextProvider>
                <GameSettingsContextProvider>
                    <PlayStateProvider>
                        <BridgeBoard />
                    </PlayStateProvider>
                </GameSettingsContextProvider>
            </DeckContextProvider>
        </FluentProvider>
    );
};

export default BridgeMain;